import { DialogContent } from "@mui/material";
import {
  BottomSheet,
  BottomSheetLoadingContent,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";
import { getSafeAreaPaddings } from "@src/appV2/redesign/system/ui-theme";

interface SubmittingLicenseBottomSheetProps {
  modalState: UseModalState;
}

export function SubmittingLicenseBottomSheet(props: SubmittingLicenseBottomSheetProps) {
  const { modalState } = props;

  return (
    <BottomSheet
      modalState={modalState}
      paperSx={{
        ...getSafeAreaPaddings({ bottom: true }),
      }}
    >
      <DialogContent sx={{ paddingX: 5 }}>
        <BottomSheetLoadingContent
          title="Submitting license"
          // todo: make description optional in ui-components
          description=""
        />
      </DialogContent>
    </BottomSheet>
  );
}
